export const SECURITY_URL = 'https://coursio.com/security/';
